<script lang="ts" context="module">
    import { z } from "zod";

    export const CustomFields = z.object({
        blink: z.boolean().default(false),

        link: z
            .object({
                url: z.string().url(),
                target: z
                    .enum(["_blank", "_self", "_parent", "_top"])
                    .optional(),
            })
            .optional(),
    });
</script>

<script lang="ts">
    import Data from "@reperio-news/core.components/blocks/Title/Data";
    import {
        stripTags,
        replaceContext,
    } from "@reperio-news/core.components/includes/Helpers";
    import { getContext } from "svelte";
    type Data = z.infer<typeof Data>;

    export let id: string;
    export let type: string;
    export let data: Data;

    const blink = data.custom_fields && data.custom_fields.blink;
    const link = data.custom_fields && data.custom_fields.link;

    const context: any = getContext("context");
</script>

<!-- svelte-ignore missing-declaration -->
{#if !data || !data.title || !data.element}
    {#if __ADMIN__}
        Title - <strong>needs configuration</strong>
    {/if}
{:else if !data.element || data.element === "h1"}
    <h1 {id} data-type={type} class:blinking={blink}>
        {#if link}
            <a href={link.url} target={link.target}
                >{stripTags(replaceContext(data.title, $context))}</a
            >
        {:else}
            {stripTags(replaceContext(data.title, $context))}
        {/if}
    </h1>
{:else if data.element === "h2"}
    <h2 {id} data-type={type} class:blinking={blink}>
        {#if link}
            <a href={link.url} target={link.target}
                >{stripTags(replaceContext(data.title, $context))}</a
            >
        {:else}
            {stripTags(replaceContext(data.title, $context))}
        {/if}
    </h2>
{:else if data.element === "h3"}
    <h3 {id} data-type={type} class:blinking={blink}>
        {#if link}
            <a href={link.url} target={link.target}
                >{stripTags(replaceContext(data.title, $context))}</a
            >
        {:else}
            {stripTags(replaceContext(data.title, $context))}
        {/if}
    </h3>
{/if}

<style lang="scss">
    h1,
    h2,
    h3 {
        a {
            color: inherit;
        }
    }

    .blinking {
        animation: blinking 1s infinite;
    }

    @keyframes blinking {
        0% {
            opacity: 0.5;
        }
        50% {
            opacity: 0.75;
        }
        99% {
            opacity: 0.85;
        }
        100% {
            opacity: 1;
        }
    }
</style>
